var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.093,
    height: 18.473,
    viewBox: "0 0 18.093 18.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.093,
    height: 18.473,
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#copy-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.354,22.52H2.738A2.74,2.74,0,0,1,0,19.783V13.166a2.741,2.741,0,0,1,2.738-2.737H9.354a2.741,2.741,0,0,1,2.738,2.737v6.617A2.741,2.741,0,0,1,9.354,22.52M2.738,11.469a1.7,1.7,0,0,0-1.7,1.7v6.617a1.7,1.7,0,0,0,1.7,1.7H9.354a1.7,1.7,0,0,0,1.7-1.7V13.166a1.7,1.7,0,0,0-1.7-1.7Z",
    transform: "translate(0 -4.047)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.161,12.091H17.7a.52.52,0,1,1,0-1.04h1.463a1.7,1.7,0,0,0,1.7-1.7V2.738a1.7,1.7,0,0,0-1.7-1.7H12.545a1.7,1.7,0,0,0-1.7,1.7V4.757a.52.52,0,0,1-1.041,0V2.738A2.741,2.741,0,0,1,12.545,0h6.616A2.741,2.741,0,0,1,21.9,2.738V9.354a2.74,2.74,0,0,1-2.738,2.737",
    transform: "translate(-3.806 0)",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.63083a1d1ce5998103c239006a35ebf8.svg";
export { ForwardRef as ReactComponent };